import { render, staticRenderFns } from "./TipoMoneda.vue?vue&type=template&id=365ec243"
import script from "./TipoMoneda.vue?vue&type=script&lang=js"
export * from "./TipoMoneda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports